import { render, staticRenderFns } from "./BooksWithMaterials.vue?vue&type=template&id=3b83d414&scoped=true"
import script from "./BooksWithMaterials.vue?vue&type=script&lang=js"
export * from "./BooksWithMaterials.vue?vue&type=script&lang=js"
import style0 from "./BooksWithMaterials.vue?vue&type=style&index=0&id=3b83d414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b83d414",
  null
  
)

export default component.exports